import { useInstance } from '@meraki-internal/react-dependency-injection';
import { DeviceInfo } from '../support/DeviceInfo';
import { DevSettings } from '../support/DevSettings';

// Returns true if native app, or web with simulateNative dev setting;
// otherwise returns false
export const useIsNative = () => {

    const deviceInfo = useInstance(DeviceInfo);
    const devSettings = useInstance(DevSettings);

    return devSettings.simulateNative || deviceInfo.platform !== 'web';
};
